import axios from 'axios'

const adminRequest = axios.create({
  // 👇 1. 修改：动态读取环境变量，并拼接咱们约定的隐藏路径
  baseURL: (process.env.VUE_APP_BASE_API || '/api') + '/sys-console-x9',
  timeout: 30000
})

adminRequest.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token')
  if (token) config.headers.Authorization = 'Bearer ' + token
  
  // 👇 2. 新增：给所有后台请求带上“暗号”请求头
  config.headers['X-Admin-Key'] = 'x9-a8f7-h2k1-secret'
  
  return config
})

// 统一处理后台登录失效
function handleAdminAuthExpired() {
  // 👇 3. 修改：判断和跳转的路径换成咱们的新路径
  if (window.location.hash === '#/sys-gateway-x9') return
  localStorage.removeItem('admin_token')
  window.location.hash = '#/sys-gateway-x9'
}

adminRequest.interceptors.response.use(
  res => {
    const data = res.data
    // 拦截业务层面的 token 失效
    if (data && data.success === false && 
       (data.msg?.includes('token') || data.msg?.includes('登录') || data.code === 401)) {
      handleAdminAuthExpired()
      return Promise.reject(new Error(data.msg || '后台登录已失效'))
    }
    return data
  },
  err => {
    console.error('请求失败', err)
    
    // 拦截 HTTP 层面的 401
    if (err.response && err.response.status === 401) {
      handleAdminAuthExpired()
      return Promise.reject(err)
    }

    return Promise.reject(err)
  }
)

export default adminRequest